export async function fetchShopOptionsCountingVisible(
  shopId: string,
): Promise<any> {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/shops/${shopId}/option/counting/visible`,
    {},
  );

  if (!res.ok) {
    return undefined;
  }

  return await res.json();
}
